export class ListConditionsService {
    constructor(httpClient) {
      this.httpClient = httpClient
    }
  
    async handle(params) {
      return await this.httpClient.get('/clientes/buscaCondicao', { params })
    }
  }
  